<template>
  <v-main>
    <section>
      <Title :title="title" :img="img"></Title>
    </section>
    <v-sheet color="rgba(245, 245, 245, 1)" height="auto" style="border: solid rgb(220, 220, 220);" align="center">
      <v-container class="mx-auto pt-12 mt-12" style="max-width: 1100px;">
        <iframe width="80%" height="5000px" class="mb-12"
                src="https://docs.google.com/spreadsheets/d/e/2PACX-1vTMAd35HC-4SBVGqc284DCp944TVi6KBGZs8yNDZ_jkxSHbY0g40HBGPCgHJyZaYh1IdimLKLzfnOp5/pubhtml?gid=0&amp;single=true&amp;widget=true&amp;headers=false"></iframe>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import Title from '../components/Title';

export default {
  name: 'TelephoneOutlineView',
  components: {
    Title,
  },
  data() {
    return {
      panel: 0,
      title: 'MOTPhone内線・外線一覧表',
      img: 'title_telephoneOutline.svg',
    };
  },
};
</script>

<style scoped>
.v-expansion-panels {
  border: 2px solid #ffffff;
  border-radius: 4px;
}

.v-expansion-panels:hover {
  border: 2px solid #0095D9;
  border-radius: 4px;
}

iframe {
  margin-top: -80px;
  margin-bottom: -80px;
}
</style>